import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../../../../auth/service";
import { AssetsService } from "../../assets.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAsset } from "../../models/assets";
import { ExportExcelComponent } from "../../../../layout/components/modals/export-excel/export-excel.component";
import { ExportExcelService } from "../../../../auth/service/export-excel.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";

@Component({
  selector: "app-assets-list",
  templateUrl: "./assets-list.component.html",
  styleUrls: ["./assets-list.component.scss"]
})
export class AssetsListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public assets: IAsset[] = [];
  public pageSize: number = 10;
  public filteredAssets: IAsset[] = [];
  public filter_rent: number = -1;
  public filter_maintenance: number = -1;
  public filter_assigned: number = -1;
  public toggleModalAssociate: boolean = false;
  public AssetIdSelectedForAssociate: number = 0;
  public windowWidth: number = 0;

  constructor(
    public _authenticationService: AuthenticationService,
    public _assetsService: AssetsService,
    public _utilService: UtilsService,
    public _router: Router,
    private activated_route: ActivatedRoute,
    private _exportExcelService: ExportExcelService,
    public _modalService: NgbModal
  ) {
    this._utilService.disableAutoHideLoading();
    this.activated_route.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const assigned = params.assigned;
      const rent = params.rent;
      const maintenance = params.maintenance;
      if (!!searchKey && searchKey != 0) {
        this.searchKeyword = searchKey;
      }
      if (!!assigned) {
        this.filter_assigned = Number(assigned);
      }
      if (!!rent) {
        this.filter_rent = Number(rent);
      }
      if (!!maintenance) {
        this.filter_maintenance = Number(maintenance);
      }
    });

    this.contentHeader = {
      headerTitle: "MENU.ASSETS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.ASSETS",
            isLink: false
          },
          {
            name: "LIST",
            isLink: false
          }
        ]
      }
    };
    this.windowWidth = window.innerWidth;
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_list_asset")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadAssets().then(() => {
      this.filterAssets();
      this._utilService.hideLoading();
    });
  }

  async loadAssets() {
    this.assets = await this._assetsService.getAllAssets();
    this.assets = this.assets.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
  }

  async dissociateAsset(AssetId: number) {
    if (!this._authenticationService.hasCapability("manage_assign_asset")) {
      window.history.back();
      return false;
    }
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DISSOCIATE_ASSET",
        icon: "warning",
        confirmButtonText: "CONFIRM_DISSOCIATE_BTN",
        customClass: {
          confirmButton: "btn btn-warning"
        }
      })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._assetsService
            .unassignAsset(AssetId)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadAssets();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DISSOCIATE_ASSET" }).then(async () => {
                await this.filterAssets();
              });
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showSWALError({ text: "ERROR_DISSOCIATE_ASSET" });
            });
        }
      });
  }

  filterAssets() {
    let items: IAsset[] = this.assets;
    const keywords: string = this.searchKeyword.trim().toLowerCase();
    if (keywords.length > 0) {
      items = items.filter(
        (item: IAsset) =>
          item.name?.toLowerCase().includes(keywords) ||
          item.serial?.toLowerCase().includes(keywords) ||
          item.product_serial_number?.toLowerCase().includes(keywords) ||
          item.category_name?.toLowerCase().includes(keywords) ||
          item.user?.complete_name?.toLowerCase().includes(keywords)
      );
    }

    if (this.filter_rent >= 0) {
      items = items.filter((item: IAsset) => Number(item.rented) === Number(this.filter_rent));
    }

    if (this.filter_maintenance >= 0) {
      items = items.filter((item: IAsset) => Number(item.inMaintenance) === Number(this.filter_maintenance));
    }

    if (this.filter_assigned >= 0) {
      items = items.filter((item: IAsset) => Number(item.assigned) === Number(this.filter_assigned));
    }

    this.filteredAssets = items;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKeyword && this.searchKeyword.length >= 3) {
      url.searchParams.set("search", this.searchKeyword);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if ((!!this.filter_assigned || this.filter_assigned === 0) && this.filter_assigned !== -1) {
      url.searchParams.set("assigned", String(this.filter_assigned));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("assigned");
      history.pushState({}, "", url);
    }

    if ((!!this.filter_rent || this.filter_rent === 0) && this.filter_rent !== -1) {
      url.searchParams.set("rent", String(this.filter_rent));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("rent");
      history.pushState({}, "", url);
    }

    if ((!!this.filter_maintenance || this.filter_maintenance === 0) && this.filter_maintenance !== -1) {
      url.searchParams.set("maintenance", String(this.filter_maintenance));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("maintenance");
      history.pushState({}, "", url);
    }
  }

  async deleteAsset(idAsset: number, assetName: string) {
    if (!this._authenticationService.hasCapability("delete_asset")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += assetName;
    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._assetsService
          .deleteAsset(idAsset)
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadAssets();
              await this.filterAssets();
            });
          })
          .catch((e) => {
            this._utilService.showSWALError({ text: e == "asset is assigned" ? "ERROR_ASSET_ASSIGNED" : "ERROR_REMOVE_ASSET" });
          });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT"
        });
      }
    });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  //Funzioni associazione modale
  showModalAdd(assetId: number) {
    this.toggleModalAssociate = true;
    this.AssetIdSelectedForAssociate = assetId;
  }

  async onAssociateModalFormEvent() {
    await this.loadAssets().then(async () => {
      await this.filterAssets();
    });
  }

  //END Funzioni associazione modale
  async export() {
    // extract labels and remove 'hash' field
    const uniqueLabels = await this._utilService.basic_get("/get-export-columns/v_asset?schema=s_asset")
      .then((result: any) =>
        (result.columns || [])
          .filter((label: string) => label !== "category" && label !== "employees")
      );
    //save in service labels and data to subscribe to export modal
    this._exportExcelService.labels.next([...uniqueLabels, "current_assigned_employee", "previous_assigned_employees", "current_assignment_start_date", "current_assignment_end_date"]);
    // setup data to export
    const dataForExport: any = this.filteredAssets.filter(u => u)
      .map((asset: any) =>
        ({
          id: asset.id,
          name: asset.name,
          description: asset.description.replace(/&nbsp;/gi,' ').trim(),
          assigned: asset.assigned,
          serial: asset.serial,
          status: asset.status,
          contract: asset.contract,
          category_name: asset.category_name,
          rented: asset.rented,
          contract_end_date: asset.contract_end_date,
          product_serial_number: asset.product_serial_number,
          license_end_date: asset.license_end_date,
          license_auto_renew: asset.license_auto_renew,
          location: asset.location,
          inMaintenance: asset.inMaintenance,
          maintenances: asset.maintenances.map((m: any) => {
            return `Data: ${moment(m.from).format("DD/MM/YYYY")} - ${moment(m.to).format("DD/MM/YYYY")}
Tipologia: ${m.type}
Note: ${m.note}`}).join(`
          ----------
          `),

          current_assignment_start_date: asset.employee?.start_date || "",
          current_assignment_end_date: asset.employee?.end_date || "",
          current_assigned_employee: asset.employee?.user?.complete_name || "",
          previous_assigned_employees: (asset.oldEmployees || []).map((employee: any) => employee?.user?.complete_name).filter((employee: string) => employee),
          attachments: asset.attachments?.map((attachment: any) => attachment.filename)
        })
      );

    this._exportExcelService.dataForExport.next(dataForExport);
    // set the file name
    this._exportExcelService.fileName.next("export-asset");
    // set the area
    this._exportExcelService.area.next("asset");

    this._modalService.open(ExportExcelComponent, {
      centered: true,
      size: "lg",
      backdrop: false,
      keyboard: false
    });
  }
}
